// extracted by mini-css-extract-plugin
export default {"image":"UserImage_image__bdNfv","container":"UserImage_container__wS1DR"};